import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-overflow-content',
    templateUrl: './overflow-content.component.html',
    animations: [
        trigger('fadeIn', [
            state('in', style({ opacity: 1 })),
            transition(':enter', [
                style({ opacity: 0 }),
                animate(600)
            ]),
        ]),
        trigger('rotated', [
            state('-180', style({ transform: 'rotate(-180deg)' })),
            state('0', style({ transform: 'rotate(0)' })),
            transition('0 => -180', animate('200ms ease-out')),
            transition('-180 => 0', animate('200ms ease-in'))
        ])
    ],
    standalone: false
})
export class OverflowContentComponent implements AfterViewInit, OnDestroy {
    @Input() overflowHidden = true;
    @Input() showToggleBtn = true;
    @Input() contentClass: any;

    @Output() overflowHiddenChange = new EventEmitter<boolean>();

    @ViewChild('content') content!: ElementRef<HTMLDivElement>;

    _cutoffHeight: string = '0';
    @Input() set cutoffHeight(cutoffHeight: string|number|null) {
        if (typeof cutoffHeight === 'number') {
            this._cutoffHeight = cutoffHeight + 'px';
        } else if (typeof cutoffHeight === 'string') {
            this._cutoffHeight = cutoffHeight;
        } else {
            this._cutoffHeight = '0';
        }
    }

    private contentResizeObserver = new ResizeObserver(entries => {
        this.showToggleBtn = entries[0].target.scrollHeight > entries[0].target.clientHeight;
    });

    ngAfterViewInit() {
        this.contentResizeObserver.observe(this.content.nativeElement);
    }

    ngOnDestroy() {
        this.contentResizeObserver.unobserve(this.content.nativeElement);
    }

    toggleOverflowHidden(): void {
        this.contentResizeObserver.unobserve(this.content.nativeElement);
        this.overflowHidden = !this.overflowHidden;
        this.overflowHiddenChange.emit(this.overflowHidden);
    }
}
